import { InjectionToken } from '@angular/core';
import { Environment } from './Environment';

export const ENV = new InjectionToken<Environment>('ENV');
